export default __webpack_public_path__ + "static/media/clock_books2.183123dd.svg";